import React, { useId } from 'react';
import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import ProductComponent from '../../components/Card/Product';

import { phpApi } from '../../utils/AxiosInstance';
import { objToCamelCase } from '../../utils/helper';

// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
import styles from '../../styles/ViewAll.module.scss';

function ViewAll({ slug, pageInfo, banners, courses }) {
  const sliderId = useId();

  return (
    <main className={styles.wrapper}>
      <Head>
        <title>{pageInfo.metaTitle}</title>
        <meta name="keywords" content={pageInfo.metaKeyword} />
        <meta name="description" content={pageInfo.metaDescription} />
        <link
          rel="canonical"
          href={`https://www.studyiq.com/view-all/${slug}`}
        />
        <meta name="robots" content="index, follow" />
      </Head>

      {banners?.length > 0 && (
        <div className={styles.sliderWrapper}>
          <Swiper
            id={sliderId}
            slidesPerView={3.4}
            spaceBetween={30}
            modules={[Autoplay]}
            autoplay={{
              delay: 5000,
            }}
            centeredSlides
            loop
          >
            {banners.map((banner) => (
              <SwiperSlide key={banner.courseSlug}>
                <Link href={`/course-detail/${banner.courseSlug}`}>
                  <Image
                    className={styles.sliderSlide}
                    src={banner.imgPath}
                    width={600}
                    height={280}
                    alt={banner.name}
                  />
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}

      <section className={styles.sectionWrapper}>
        <h1 className={styles.sectionName}>{pageInfo.sectionName}</h1>
        <div className={styles.courseGrid}>
          {courses.map((course) => (
            <ProductComponent
              key={course.courseSlug}
              product={objToCamelCase(course)}
            />
          ))}
        </div>
      </section>
    </main>
  );
}

export const getServerSideProps = async ({ params: { slug } }) => {
  const props = { slug };

  try {
    const response = await phpApi.get('/get_menu_section');
    const { success, data } = response.data;
    if (success) {
      const { banner, sections } = data;

      props.banners = objToCamelCase(banner);
      props.sections = sections;
    }
  } catch (error) {
    // Handle Error
  }

  try {
    const response = await phpApi.get(`/viewallcourses/${slug}`);

    const { success, data } = response.data;
    if (success) {
      const { courses, ...pageInfo } = data;

      if (courses?.length > 0) {
        return {
          props: {
            ...props,
            slug,
            pageInfo: objToCamelCase(pageInfo),
            courses,
          },
        };
      }
    }
  } catch (error) {
    // Handle Error
  }

  return {
    redirect: {
      permanent: false,
      destination: '/',
    },
  };
};

export default ViewAll;
